import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationEventSearchCriteria extends ModelBase {
    public organisationName: string = "";

    public staticEventName: string = "";
}